



























































































































































































































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {HostReservationIdRequests} from "@/helpers";

@Component
export default class HostReservations extends Vue {
  localReservations: any[] = [];
  completedReservations: any[] = [];
  confirmedReservations: any[] = [];
  waitingReservations: any[] = [];
  rejectedReservations: any[] = [];
  revokedReservations: any[] = [];
  loading: boolean = false;

  // @Watch("reservation", { immediate: true, deep: true })
  // onReservationsChanged(val: string) {
  //   this.parseReservations();
  // }

  @Prop({default: []}) private reservations!: Array<any>;

  parseReservations() {
    this.reservations.map((item: any) => {
      if (item.aasmState === "waiting") this.waitingReservations.push(item);
      if (item.aasmState === "confirmed") this.confirmedReservations.push(item);
      // if (item.aasmState === "completed") this.completedReservations.push(item);
      if (item.aasmState === "rejected") this.rejectedReservations.push(item);
      if (item.aasmState === "revoked") this.revokedReservations.push(item);
    });
    this.localReservations.push(
      this.waitingReservations,
      this.confirmedReservations,
      // this.completedReservations,
      this.rejectedReservations,
      this.revokedReservations
    );
  }

  logout() {
    this.$store
      .dispatch("session/logout")
      .then((): any => this.$router.replace(this.$route.path))
      .catch((error: Error) => {
        this.$store.dispatch("app/setSnackbarMessage", {
          message: error,
          color: "red"
        });
        this.$store.commit("session/cleanCurrentUser");
        // this.$router.push(`/${this.$i18n.locale}/login`);
      });
  }

  removeReservationFromListById(id: any) {
    for (var i = this.reservations.length - 1; i >= 0; --i) {
      if (this.reservations[i].id === id) {
        this.reservations.splice(i, 1);
      }
    }
  }

  openConfirmationDialog(action: string, id: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.$store
        .dispatch("app/setDialog", {
          type: "confirmation",
          state: true,
          childData: {
            title: this.$t('confirmation.reservationManager.title'),
            content: this.$t('confirmation.reservationManager.content'),
            ok: this.$t('confirmation.reservationManager.ok'),
            ko: this.$t('confirmation.reservationManager.ko')
          },
          callback: () => {
            this.proceedWithReservationAction(action, id)
          }
        })
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }

  proceedWithReservationAction(action: string, id: any) {
    this.loading = true;
    if (action === "accept") {
      HostReservationIdRequests.with({
        reservationId: `${id}/confirm`
      })
        .create()
        .then((response: any) => {
          this.removeReservationFromListById(id);
          this.$emit("reservationAction");
          this.loading = false;
        })
        .catch((error: any) => {
          this.$store.dispatch("app/setSnackbarMessage", {
            message: error.data.errors[0].title,
            color: "red"
          });
          this.loading = false;
          // console.warn("accept: ", error);
        });
      // console.warn("accept");
    }
    if (action === "reject") {
      HostReservationIdRequests.with({
        reservationId: `${id}/reject`
      })
        .create()
        .then((response: any) => {
          this.removeReservationFromListById(id);
          this.$emit("reservationAction");
          this.loading = false;
        })
        .catch((error: Error) => {
          this.$store.dispatch("app/setSnackbarMessage", {
            message: error,
            color: "red"
          });
          this.loading = false;
          // console.warn("reject: ", error);
        });
    }
  }

  reservationHandler(action: string, id: any) {
    this.openConfirmationDialog(action, id)

  }
}
